<div class="max-w-md mx-auto">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
    class="flex items-center justify-between">
    <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">currency_exchange</mat-icon>
      Actualizar Tasa negociación USDT
    </h2>
    <button type="button" (click)="onNoClick()"
      style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="p-6">
    <form *ngIf="formCuenta" [formGroup]="formCuenta" class="space-y-4">
      <mat-form-field appearance="outline" class="modern-field w-full">
        <mat-label>Tasa USDT</mat-label>
        <input type="text" appOnlynumber matInput formControlName="tasaCLPUSDT">
        <mat-error *ngIf="formCuenta.get('tasaCLPUSDT')?.errors?.['greaterThanZero'] === true">Debe ser mayor que 0</mat-error>
        <mat-error *ngIf="formCuenta.get('tasaCLPUSDT')?.hasError('maxlength')">Debe tener menos de 9 caracteres</mat-error>
      </mat-form-field>

      <div class="flex justify-center">
        <button type="button" (click)="actualizarTasas()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
          Actualizar
        </button>
      </div>
    </form>
  </div>
</div>
